import { render, staticRenderFns } from "./ShopInfoSelector.vue?vue&type=template&id=28576a96&scoped=true&"
import script from "./ShopInfoSelector.vue?vue&type=script&lang=js&"
export * from "./ShopInfoSelector.vue?vue&type=script&lang=js&"
import style0 from "./ShopInfoSelector.vue?vue&type=style&index=0&id=28576a96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28576a96",
  null
  
)

export default component.exports